import { useState, useEffect } from "react";
import Helper from "../functions/Helper.js";

function getShoeData(url, currentShoe, shoeList) {
  if (currentShoe?.url === url) {
    return currentShoe;
  } else {
    return Helper.getShoe(url, shoeList);
  }
}

export const useShoe = (url, currentShoe, shoeList, fetchShoe) => {
  const [returnShoe, setReturnShoe] = useState(
    getShoeData(url, currentShoe, shoeList)
  );
  useEffect(() => {
    setReturnShoe(getShoeData(url, currentShoe, shoeList));
  }, [currentShoe, shoeList, url]);

  useEffect(() => {
    if (currentShoe?.url === url) {
      //loading same Shoe again
      if (!currentShoe?.COMPLETE_LOAD) {
        Helper.fetchShoeData(url).then((x) => {
          fetchShoe(x);
        });
      }
    } else {
      let tempShoe = Helper.getShoe(url, shoeList);

      fetchShoe(tempShoe);
      if (!tempShoe?.COMPLETE_LOAD ?? false) {
        Helper.fetchShoeData(url).then((x) => {
          fetchShoe(x);
        });
      }
    }
  }, []);
  return returnShoe;
};
